import http from '@/http/driver'

export default {
    planner: {
        search(data = {}) {
            return http({ url: '/v1/journey-planner/search', method: 'post', data })
        },
        getJourneys(hash) {
            return http({ url: `/v1/journey-planner/search/${hash}` })
        },
        getSingleJourney(hash, journeyID) {
            return http({ url: `/v1/journey-planner/search/${hash}/${journeyID}` })
        },
        updateReturnTime(hash, data = {}) {
            return http({ url: `/v1/journey-planner/search/${hash}/update-return-time`, method: 'post', data })
        },
        getPlannerDestinations(search) {
            return http({ url: `/v1/journey-planner/destinations?search=${search}` })
        },
    },
    journey: {
        journeyViewed(journeyID) {
            return http({
                url: `/v1/journey/viewed/${journeyID}`,
                method: 'post',
            })
        },
    },
    campaigns: {
        getActiveCampaign(params) {
            return http({
                url: '/v1/campaign',
                method: 'get',
                params,
            })
        },
        recordCampaignImpression(params) {
            return http({
                url: `/v1/campaign/${params.campaign_id}/impression`,
                method: 'post',
                data: params,
            })
        },
    },
}
